import {useState} from 'react'
import {Pressable, View} from 'react-native'
import {Trans} from '@lingui/macro'

import {atoms as a, useTheme, web} from '#/alf'
import {Divider} from '#/components/Divider'
import {ChevronBottom_Stroke2_Corner0_Rounded as ChevronDown} from '#/components/icons/Chevron'
import {Text} from '#/components/Typography'

interface Rule {
  id: number
  title: string
  description?: string
}

const RULES: Rule[] = [
  {
    id: 1,
    title: '18+ only',
    description:
      'Our terms and community guidelines prohibit people below the age of 18 to join including the prohibition for anyone to distribute child sexual abuse material, or any content portraying minors in a sexually explicit context.',
  },
  {
    id: 2,
    title: 'Respect others privacy',
    description:
      'We take reasonable efforts to protect the privacy of our members. Do not screenshot or screen record others without their explicit consent.',
  },
  {
    id: 3,
    title: 'Promoting drug use',
    description:
      'No references or posts about illegal substances. Poppers, Alcohol, and Weed are allowed.',
  },
  {
    id: 4,
    title: 'Remember the human',
    description:
      'Everyone has the right to use Batesky free of harassment, bullying, and threats of violence. Any posts or comments that violate this rule will be removed and the user may be banned. We strive to create a safe and welcoming environment for everyone.',
  },
]

export function RoomRulesSection() {
  const t = useTheme()
  const [expandedRules, setExpandedRules] = useState<number[]>([])

  const toggleRule = (ruleId: number) => {
    setExpandedRules(prev =>
      prev.includes(ruleId)
        ? prev.filter(id => id !== ruleId)
        : [...prev, ruleId],
    )
  }

  return (
    <>
      <View style={[a.gap_sm, {paddingBottom: 2}]}>
        <View style={[a.flex_row, a.align_center, a.gap_xs]}>
          <Text
            style={[
              a.flex_1,
              a.text_sm,
              a.font_bold,
              t.atoms.text_contrast_medium,
            ]}>
            <Trans>Batesky Rooms Rules</Trans>
          </Text>
        </View>

        <View style={[a.gap_xs]}>
          {RULES.map(rule => {
            const isExpanded = expandedRules.includes(rule.id)
            const hasDescription = !!rule.description

            return (
              <View key={rule.id}>
                <Pressable
                  accessibilityRole="button"
                  style={[
                    a.flex_row,
                    a.align_start,
                    a.gap_xs,
                    a.py_sm,
                    hasDescription && web({cursor: 'pointer'}),
                  ]}
                  onPress={() => hasDescription && toggleRule(rule.id)}
                  disabled={!hasDescription}>
                  <Text
                    style={[
                      a.text_sm,
                      a.font_bold,
                      t.atoms.text_contrast_high,
                      {minWidth: 16},
                    ]}>
                    {rule.id}
                  </Text>
                  <View style={[a.flex_1, a.gap_xs]}>
                    <View style={[a.flex_row, a.align_center, a.gap_xs]}>
                      <Text
                        style={[
                          a.flex_1,
                          a.text_sm,
                          a.font_bold,
                          t.atoms.text_contrast_high,
                        ]}>
                        {rule.title}
                      </Text>
                      {hasDescription && (
                        <View
                          style={[
                            {
                              transform: [
                                {rotate: isExpanded ? '180deg' : '0deg'},
                              ],
                            },
                          ]}>
                          <ChevronDown size="xs" />
                        </View>
                      )}
                    </View>
                    {isExpanded && rule.description && (
                      <Text
                        style={[
                          a.text_xs,
                          a.leading_snug,
                          t.atoms.text_contrast_medium,
                        ]}>
                        {rule.description}
                      </Text>
                    )}
                  </View>
                </Pressable>
                {rule.id < RULES.length && (
                  <View style={{paddingLeft: 24}}>
                    <Divider />
                  </View>
                )}
              </View>
            )
          })}
        </View>
      </View>
      <Divider />
    </>
  )
}
